import {
  Component,
  EventEmitter,
  Output,
  Input,
  SimpleChanges,
} from "@angular/core";
import { getSelectedPeriodBasis } from "@va/core-library/period-filter";
import {
  getPeriodTypeDataId,
  getSelectedPeriods,
} from "src/app/utils/period-utils";

@Component({
  selector: "app-drug-page-grid-controls",
  templateUrl: "./drug-page-grid-controls.component.html",
  styleUrls: ["./drug-page-grid-controls.component.scss"],
})
export class DrugPageGridControlsComponent {
  @Input() periodRange = [];
  @Output() dataSettingsChanged: EventEmitter<any> = new EventEmitter();

  //Period filter
  defaultPeriodObj = {
    is_annual_selected: true,
    period_basis: {
      abs: {
        from_basis: [
          {
            label: "",
            name: "Y",
            selected: true,
          },
        ],
        to_basis: [
          {
            label: "",
            name: "Y",
            selected: true,
          },
        ],
      },
      rel: {
        from_basis: [
          {
            label: "",
            name: "Y",
            selected: false,
          },
        ],
        to_basis: [
          {
            label: "",
            name: "Y",
            selected: false,
          },
        ],
      },
    },
    basis: [
      {
        label: "Calendar",
        name: "cal",
        selected: false,
      },
      {
        label: "Fiscal",
        name: "fy",
        selected: true,
      },
    ],
    from_to: {
      selected_from: new Date().getFullYear() - 2,
      selected_to: new Date().getFullYear() + 7,
    },
    other_period: [],
    type: [
      {
        label: "Absolute",
        name: "abs",
        selected: true,
      },
      {
        label: "Relative",
        name: "rel",
        selected: false,
      },
    ],
  };
  periodObj = {
    period: getSelectedPeriods(this.defaultPeriodObj, false),
    periodStart: -2,
    periodEnd: 7,
    period_type: "absolute",
    period_basis: "fiscal",
  };
  periodMinMax = {
    min: -15,
    max: 25,
  };

  //Data/Revisoin filter
  dataView: { view_by: any[]; revision: string } = {
    view_by: ["values"],
    revision: "",
  };

  //Currency filter
  selectedCurrency = "Base";
  currencyDisabled = false;
  apiEP: string = window.apiUrl;

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.periodRange && changes.periodRange.currentValue) {
      const from = this.periodRange[0];
      const to = this.periodRange[1];

      this.defaultPeriodObj.from_to.selected_from =
        new Date().getFullYear() + from;
      this.defaultPeriodObj.from_to.selected_to = new Date().getFullYear() + to;

      this.periodObj = {
        ...this.periodObj,
        period: getSelectedPeriods(this.defaultPeriodObj, false),
        periodStart: from,
        periodEnd: to,
      };
    }
  }

  periodSettingsChange(param) {
    const { updatedPeriodData, periodUserSettingData } = param;
    const selectedPeriodList = getSelectedPeriods(
      param.updatedPeriodData,
      false,
    );
    const periodType = getPeriodTypeDataId(updatedPeriodData);
    const basisValue =
      getSelectedPeriodBasis(updatedPeriodData.basis) === "cal"
        ? "calendar"
        : "fiscal";

    this.periodObj.period = selectedPeriodList;
    this.periodObj.period_basis = basisValue;
    this.periodObj.period_type = periodType;
    this.periodObj.periodStart = periodUserSettingData.from;
    this.periodObj.periodEnd = periodUserSettingData.to;
    this.defaultPeriodObj = updatedPeriodData;
    this.emitOutput();
  }

  updateDataView($event) {
    this.dataView = { view_by: $event.viewBy, revision: $event.revision };
    this.emitOutput();
  }

  onCurrencyChange(currency) {
    this.selectedCurrency = currency;
    this.emitOutput();
  }

  emitOutput() {
    this.dataSettingsChanged.emit({
      currency: this.selectedCurrency === "Base" ? "" : this.selectedCurrency,
      periodData: { ...this.periodObj },
      view_by: this.dataView.view_by,
      revision: this.dataView.revision,
    });
  }
}
